export default __webpack_public_path__ + "static/media/line.a941a19b.svg";